// Import all stores
import { createStore } from "vuex";
import products from "./products/productsStore.js";

// Create Vuex store with named modules
const store = createStore({
  modules: {
    products,
  },
});

export default store;
